import React, { useCallback, useContext, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { AppBar, Badge, Box, IconButton, Toolbar, InputBase, Divider } from "@mui/material";
import { ReactComponent as Nine_dots } from "assets/icons/9_dots/Nine_dots.svg";
import { ReactComponent as Menubar } from "assets/icons/9_dots/menu_bar.svg";
import SearchIcon from "@mui/icons-material/Search";
import { ReactComponent as LogoutIcon } from "assets/icons/logout.svg";
import CatalogueEditHeader from "./CatalogueEditHeader";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "components/ui/Button";
import { useGlobalContext } from "context/GlobalContext";
import CartShowHeader from "./CartShowHeader";
import CartIcon from "components/Icons/CartIcon";
import NotificationIcon from "components/Icons/NotificationIcon";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import SortContext from "context/SortContext";
import EditSetHeader from "./EditSetHeader";
import { debounce, set } from "lodash";
import OrdersNotificationModal from "features/Setting/order/components/OrdersNotificationModal";
import Tooltip from "components/ui/Tooltip";
import EditCatagoryHeader from "./EditCatagoryHeader";
import SettingHeader from "./SettingHeader";
import RightSideBarModal from "components/ui/RightSideBarModal/RightSideBarModal";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import QuickCreate from "components/Icons/QuickCreate";
import QuickDrawer from "components/ui/QuickDrawer/QuickDrawer";
import list from "../../db/drawerOptions.json";
// import { useCart } from "context/CartContext";
import { useDispatch, useSelector } from "react-redux";
import { clearCart, clearMeltingCart } from "store/cartSlice";
import apiClient from "lib/api-client";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
  marginLeft: 0,
  width: "100%",
  boxShadow: "inset 0px 4px 20px 0px #00000040",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    transition: theme.transitions.create("width"),

    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  width: "100%",
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: "#E77B7B",
  border: "1px solid #E77B7B",
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#E77B7B",
    color: "black",
  },
}));

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [cancelDesignModal, setCancelDesignModal] = useState(false);
  // const [countCart, setCountCart] = useState(0);
  const { setCountCart, setDynamicFilterCount } = useGlobalContext();
  // const {cartData} = useCart();
  const dispatch = useDispatch();

  const standardCartCount = useSelector((state) => state.cart.cartData.length);
  const meltingCartCount = useSelector((state) => state.cart.meltingCartData.length);

  const isMeltingStock = location?.state?.newName === "Create Melting Stock" || location?.state?.isMeltingFlow === true;
  const isCrmFlow = Boolean(location?.state?.crmSource);
  const countCart = standardCartCount;

  const [logoutModal, setLogoutModal] = useState(false);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [cancelDesignModaleHeding, setCancelDesignModalHeading] = useState("Do you want to Discard the Cart ?");
  const { isEdit, setSearch, search, isCollectionEdit } = useContext(SortContext);
  let [state, setState] = useState({});
  // const state = location.state;
  // const editValue = state && state.edit ? state.edit : false;
  const editValue = location?.state && location?.state?.edit ? location?.state?.edit : false;
  const catalogueName = state && state.catalogueName ? state.catalogueName : null;
  // const collectionName = state && state.collectionName ? state.collectionName : null;

  const innerChnages = state && state?.innerChnages ? state?.innerChnages : false;
  const newName = state && state?.newName ? state?.newName : null;
  const resolvedCatalogueName = React.useMemo(() => {
    if (catalogueName) return catalogueName;

    const source = state?.name?.[0] || state?.backName?.[0] || "";
    const bracketMatch = source.match(/\(([^)]+)\)/);
    if (bracketMatch?.[1]) {
      return bracketMatch[1].trim();
    }

    return source.replace(/^#?\d+\s*/, "").trim();
  }, [catalogueName, state]);

  const headerTitle =
    state?.cataloguUpdate && resolvedCatalogueName
      ? `${resolvedCatalogueName} Catalog`
      : catalogueName
        ? catalogueName
        : state?.crmSource && state?.crmFlowName
          ? state.crmFlowName
          : newName === "Create Order"
            ? "Create Quote"
            : newName;
  const openCart = location?.state && location?.state?.openCart ? location?.state?.openCart : false;
  const clientDetails = state && state?.clientDetails ? state?.clientDetails : false;
  const archiveCatalog = state && state?.archiveCatalog ? state?.archiveCatalog : false;

  /* Calculate Count For Cart Icon Badge */
  const { showCollectionTrashIcon, setAddDesignBtn, searchPlaceHolder, rightSideBar, setRightSideBar, setCartData, notificationCount, setNotificationCount } = useGlobalContext();
  // const [notificationCount, setNotificationCount] = useState(0);
  const [tempSearch, setTempSearch] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [clearCartModal, setClearCartModal] = useState(false);

  const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  };

  const updateNotificationData = async () => {
    try {
      const res = await apiClient.put("/api/v1/melting_request/meltingLogs/readMeltingRequest");
    } catch (error) {
      console.log("there was a error", error);
    }
  };

  const modalBtnInfo = React.useMemo(
    () => [
      {
        btnName: "log out",
        bgColor: "#E77B7B",
        click: handlelogout,
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setLogoutModal(false),
      },
    ],
    []
  );

  useEffect(() => {
    function getCookie(name) {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith(name + "="))
        ?.split("=")[1];
    }
    const cookieValue = parseInt(getCookie("notificationCount") || "0", 10);
    const meltingValue = parseInt(getCookie("totalMeltingNotificationCount") || "0", 10);
    setNotificationCount(cookieValue + meltingValue);
  }, [notificationCount]);

  const handleCancle = () => {
    if (innerChnages) {
      if (!countCart) {
        if (state?.cataloguUpdate) {
          state = {
            // ...state,
            name: location?.state?.backName,
            catalogSearch: "",
            view: false,
            // subName: "Edit",
            // edit: true,
            // innerChnages: false,
          };

          // navigate(state.backPath === "/Order" ? "/" : state.backPath, { state });
          navigate(location?.state?.backPath, { state });
        } else if (state?.collectionUpdate) {
          state = {
            ...state,
            name: state.backName,
            innerChnages: false,
            collection: true,
          };
          // navigate(state.backPath === "/Order" ? "/" : state.backPath, { state });
          navigate(state?.backPath, { state });
        } else {
          if (isCrmFlow) {
            window.location.replace(state?.backPath);
            return;
          }
          navigate(state?.backPath);
        }
        // setCountCart(0);
        sessionStorage.removeItem("CartData");
      } else {
        if (isMeltingStock) {
          setCancelDesignModalHeading("Do you want to discard all changes?");
        } else if (state?.backPath) {
          let headingSection =
            state?.newName === "Create Order" ? "quote" : state?.backPath?.includes("/Catalog") || state?.backPath?.includes("/Collection") ? state?.backPath?.split("/")[1] : state?.backPath.slice(1);
          headingSection = `Do you want to Discard the ${headingSection} ?`;
          setCancelDesignModalHeading(headingSection);
        }
        setCancelDesignModal(true);
      }
    }
  };

  const cancelDesignModalBtnInfo = [
    {
      btnName: "Discard",
      bgColor: "#E77B7B",
      click: () => {
        if (state?.cataloguUpdate) {
          if (state?.backPath === "/Order") {
            state = {
              ...state,
              name: state.backName,
              subName: "Edit",
              edit: true,
              innerChnages: false,
            };
          } else {
            state = {
              // ...state,
              name: state.backName,
              view: false,
              // subName: "Edit",
              // edit: true,
              // innerChnages: false,
            };
          }
          navigate(state.backPath === "/Order" ? "/" : location.state.backPath, { state });
        } else if (state?.collectionUpdate) {
          state = {
            ...state,
            name: state.backName,
            innerChnages: false,
            collection: true,
          };
          setAddDesignBtn(false);

          navigate(state?.backPath === "/Order" ? "/" : state.backPath, { state });
        } else {
          if (isCrmFlow) {
            window.location.replace(state?.backPath);
            return;
          }
          navigate(state?.backPath === "/Order" ? "/" : state.backPath);
        }
        // setCountCart(0);
        sessionStorage.removeItem("RecentlyRemoved");
        sessionStorage.removeItem("CartData");
        sessionStorage.removeItem("clientFormData");
        // setCartData([]);
        if (isMeltingStock) {
          dispatch(clearMeltingCart());
        } else {
          dispatch(clearCart());
        }
        setCancelDesignModal(false);
      },
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => setCancelDesignModal(false),
    },
  ];

  const clearCartBtnInfo = [
    {
      btnName: "Clear",
      bgColor: "#E77B7B",
      click: () => handleDiscardChanges(),
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => setClearCartModal(false),
    },
  ];

  const handleDiscardChanges = useCallback(() => {
    // setCountCart(0);
    // sessionStorage.removeItem("CartData");
    if (isMeltingStock) {
      dispatch(clearMeltingCart());
    } else {
      dispatch(clearCart());
    }
    sessionStorage.removeItem("clientFormData");
    setCartData([]);
    sessionStorage.removeItem("createName");
    setClearCartModal(false);
    if (Boolean(state?.crmSource)) {
      window.location.replace(state?.backPath);
      return;
    }
    navigate(state?.backPath);
  }, [setCountCart, isMeltingStock, state]);

  const handleShowCart = () => {
    // If Melting Flow, check if Cart is empty
    const isMeltingFlow = state?.newName?.includes("Melting Stock");
    if (isMeltingFlow && countCart === 0) {
      return; // Do not open cart if empty
    }

    if (innerChnages || clientDetails) {
      state = { ...state, openCart: true, clientDetails: false, innerChnages: true };
      // state = { ...state, openCart: true, clientDetails: false, innerChnages: true ,isMeltingFlow:true,isMeltingFlowName:"Create Melting Stock"};
      if (state?.newName?.split("Create ")[1] === "Order") {
        state.newName = "Cart";
        return navigate("/CartOrder", { state });
      }
      if (state?.newName?.split("Create ")[1] === "Melting Stock") {
        return navigate("/CartOrder", {
          state: {
            ...state,
            newName: "Cart",
            isMeltingFlow: true,
            isMeltingFlowName: "Create Melting Stock header",
          },
        });
      }
      if (isCrmFlow) {
        return navigate("/CartOrder", { state });
      }
      navigate("/Cart", { state });
    }
  };

  function handlelogout() {
    localStorage.clear();
    navigate("/login");
  }

  const handleSearch = () => {
    setSearch(tempSearch);
    setDynamicFilterCount(false);
  };

  useEffect(() => {
    setTempSearch(search);
  }, [search]);

  useEffect(() => {
    if (tempSearch === "") {
      setSearch("");
    }
  }, [tempSearch]);

  useEffect(() => {
    setState(location.state);
  }, [location]);

  // const updateCartCount = () => {
  //   setCountCart(cartData.length);
  // };

  // useEffect(() => {
  //   updateCartCount();

  //   const handleCartUpdated = () => {
  //     updateCartCount();
  //   };

  //   window.addEventListener("cartUpdated", handleCartUpdated);

  //   return () => {
  //     window.removeEventListener("cartUpdated", handleCartUpdated);
  //   };
  //   // }, []);
  // }, [cartData]);

  // useEffect(() => {
  //   console.log("Updated isEdit:", isEdit);
  // }, [isEdit]);

  return (
    <>
      <AppBar position="fixed" elevation={0} sx={{ backgroundColor: "#000", padding: "5px 15px 2px 5px" }}>
        <Toolbar>
          {!innerChnages ? <Box sx={{ flexGrow: 1 }} /> : <Box sx={{ flexGrow: 1, fontWeight: 400, fontSize: "24px" }}>{headerTitle}</Box>}

          {isEdit === "click" || isCollectionEdit === "click" ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
              <EditSetHeader />
            </Box>
          ) : null}

          {location?.state?.isEditCatagory ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
              <EditCatagoryHeader />
            </Box>
          ) : null}

          {/* {location?.state?.isRestricted ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
              <SettingHeader />
            </Box>
          ) : null} */}

          {!clientDetails ? (
            <Box sx={{ display: isEdit === "click" || isCollectionEdit === "click" || location?.state?.isEditCatagory ? "none" : null }}>
              {!editValue ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",

                    gap: !innerChnages ? 1.8 : 3,
                    width: "100%",
                    marginLeft: !innerChnages ? "0px" : "15px",
                  }}
                >
                  {!openCart ? (
                    <>
                      <Search
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "10px",
                          paddingRight: "4px",
                        }}
                      >
                        {/* Search Icon inside Input */}
                        <SearchIconPlaceHolder sx={{ color: "gray", marginRight: "8px" }} />

                        <StyledInputBase
                          placeholder={searchPlaceHolder}
                          onChange={(e) => setTempSearch(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSearch();
                            }
                          }}
                          value={tempSearch}
                          inputProps={{ "aria-label": "search" }}
                          sx={{ height: "40px", borderRadius: "5px" }}
                        />

                        <IconButton
                          disableRipple
                          disableFocusRipple
                          sx={{
                            color: "black",
                            height: "34px",
                            width: "69px",
                            borderRadius: "5px",
                            padding: "10px",
                            background: "#000",
                            fontFamily: "poppins",
                            color: "#fff",
                            fontWeight: "500",
                            fontSize: "12px",
                          }}
                          onClick={search === "" ? handleSearch : () => setSearch("")}
                        >
                          {search === "" ? "Search" : "Clear"}
                        </IconButton>
                      </Search>

                      {!innerChnages && (
                        <Tooltip title="Quick Create" marginTop="-5px">
                          <IconButton size="large" edge="end" disableRipple disableFocusRipple onClick={() => setDrawerOpen(true)}>
                            <QuickCreate />
                          </IconButton>
                        </Tooltip>
                      )}
                      <QuickDrawer open={drawerOpen} handleClose={() => setDrawerOpen(false)} data={list} />

                      {!archiveCatalog && (
                        <Tooltip title="Cart" marginTop="-5px">
                          <IconButton size="large" edge="end" color="success" disableRipple disableFocusRipple onClick={handleShowCart} sx={{ pointerEvents: !countCart ? "none" : "auto" }}>
                            <Badge
                              badgeContent={countCart}
                              color="success"
                              sx={{
                                mr: !innerChnages ? "auto" : "10px",
                              }}
                            >
                              <CartIcon color={!countCart ? "white" : "#50C878"} />
                            </Badge>
                          </IconButton>
                        </Tooltip>
                      )}
                    </>
                  ) : (
                    <CartShowHeader Search={Search} StyledInputBase={StyledInputBase} btnTitle={newName || ""} setCountCart={setCountCart} countCart={countCart} origin={state} />
                  )}

                  {!innerChnages ? (
                    <Tooltip title="Notifications" marginTop="-5px">
                      {/* {notificationCount > 0 && <div>notificationCount</div>} */}
                      <IconButton
                        size="large"
                        color="success"
                        disableRipple
                        disableFocusRipple
                        onClick={async () => {
                          await updateNotificationData();
                          setNotificationCount(0);
                          setCookie("notificationCount", 0);
                          setCookie("totalMeltingNotificationCount", 0);
                          setOrderModalOpen(true);
                        }}
                      >
                        <Badge badgeContent={notificationCount} color="success">
                          <NotificationIcon color={notificationCount === 0 ? "white" : "#50C878"} />
                        </Badge>
                      </IconButton>
                    </Tooltip>
                  ) : openCart ? (
                    ""
                  ) : (
                    <>
                      <StyledButton onClick={handleCancle}>Cancel</StyledButton>
                      {cancelDesignModal && (
                        <RemoveModal
                          open={cancelDesignModal}
                          setOpen={setCancelDesignModal}
                          btnInfo={cancelDesignModalBtnInfo}
                          heading={isMeltingStock ? "Do you want to discard all changes?" : cancelDesignModaleHeding}
                        />
                      )}
                    </>
                  )}
                </Box>
              ) : (
                <CatalogueEditHeader Search={Search} StyledInputBase={StyledInputBase} catalogueName={catalogueName || ""} />
              )}
            </Box>
          ) : null}
          {/* <Box sx={{ display: isEdit === "click" || isCollectionEdit === "click" || editValue || location?.state?.isEditCatagory ? "none" : null }}>
            <Tooltip title="Log-Out" marginTop="-5px">
              <IconButton size="large" edge="end" color="success" onClick={() => setLogoutModal(true)} disableRipple disableFocusRipple>
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </Box> */}
          {/* <Box>
          <Tooltip title="9 dots" marginTop="-5px">
          <Box>
          <Tooltip title="Menu" marginTop="-5px">
              <IconButton size="large" edge="end" color="success" onClick={() => setRightSideBar(true)} disableRipple disableFocusRipple>
                {rightSideBar ? <Menubar /> : <Nine_dots />}
              </IconButton>
            </Tooltip>
          </Box> */}
          {!innerChnages && isEdit !== "click" && isCollectionEdit !== "click" && !clientDetails && (
            <Box>
              <Tooltip title="Menu" marginTop="-5px">
                <IconButton size="large" edge="end" color="success" onClick={() => setRightSideBar(true)} disableRipple disableFocusRipple>
                  {rightSideBar ? <Menubar /> : <Nine_dots />}
                </IconButton>
              </Tooltip>
            </Box>
          )}

          {clientDetails && (
            <Box sx={{ display: null }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  gap: 3,
                  width: "100%",
                  marginLeft: "15px",
                }}
              >
                <>
                  <Tooltip title="Cart" marginTop="-5px">
                    <IconButton size="large" edge="end" color="success" disableRipple disableFocusRipple onClick={handleShowCart}>
                      <Badge
                        badgeContent={countCart}
                        color="success"
                        sx={{
                          mr: "auto",
                        }}
                      >
                        <CartIcon color={!countCart ? "white" : "#50C878"} />
                      </Badge>
                    </IconButton>
                  </Tooltip>

                  <Box key={"Clear Cart"}>
                    <StyledButton bgcolor="#E77B7B" onClick={() => setClearCartModal(true)}>
                      Clear Cart
                    </StyledButton>
                  </Box>
                  {clearCartModal && <RemoveModal open={clearCartModal} setOpen={setClearCartModal} heading="Do you want to clear the cart?" btnInfo={clearCartBtnInfo} />}
                </>
              </Box>
            </Box>
          )}

          {location.pathname === "/CartOrder" && newName !== "Create Melting Stock" && !isMeltingStock && (
            <Box sx={{ display: null }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  // gap: 3,
                  width: "100%",
                  marginLeft: "19px",
                }}
              >
                <>
                  <Box key={"Clear Cart"}>
                    <StyledButton bgcolor="#E77B7B" onClick={() => setClearCartModal(true)}>
                      Clear Cart
                    </StyledButton>
                  </Box>
                  {clearCartModal && <RemoveModal open={clearCartModal} setOpen={setClearCartModal} heading="Do you want to clear the cart?" btnInfo={clearCartBtnInfo} />}
                </>
              </Box>
            </Box>
          )}
        </Toolbar>
        {/* display: !editValue ? null : "none" */}
      </AppBar>
      <Box
        sx={{
          border: "1px solid #000",
          display: "flex",
          justifyContent: "center",
          padding: "0px",
          paddingBottom: "10px",
          position: "sticky",
          zIndex: "1000",
          top: "71px",
          backgroundColor: "black !important",
        }}
        maxWidth={"100%"}
      >
        {/* <Divider orientation="horizontal" flexItem style={{ borderColor: "#444444", width: !innerChnages && !editValue ? "95.4%" : "97%" }} /> */}
        <Divider
          orientation="horizontal"
          flexItem
          style={{
            borderColor: "#444444",
            // height: location.pathname === "/CartOrder" ? "5px" : "0px",
            width: location.pathname === "/CartOrder" ? "99.3%" : !innerChnages && !editValue ? "96.4%" : "97%",
            // boxShadow: location.pathname === "/CartOrder" ? "0vw .2vw .5vw rgba(236, 230, 230, 0.09)" : "",
          }}
        />
      </Box>
      {/* <RemoveModal open={logoutModal} setOpen={setLogoutModal} btnInfo={modalBtnInfo} heading="Are you sure you want to log out?" /> */}
      <OrdersNotificationModal open={orderModalOpen} handleClose={() => setOrderModalOpen(false)} />
      <RightSideBarModal open={rightSideBar} setOpen={setRightSideBar} modalBtnInfo={modalBtnInfo} logoutModal={logoutModal} setLogoutModal={setLogoutModal} />
    </>
  );
};

export default Header;
